// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css — fully responsive with perfect underline + mobile tab layout */

/* -------------------------
   Theme Variables
------------------------- */
:root {
  --bg-page: rgb(249, 243, 243);
  --surface: #ffffff;
  --text: #111827;
  --muted: #6b7280;
  --accent-500: #6366f1;
  --accent-600: #4f46e5;
  --accent-700: #4338ca;
  --radius: 1rem;
  --shadow-sm: 0 4px 12px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 6px 20px rgba(0, 0, 0, 0.08);
  --success: #10b981;
  --danger: #ef4444;

  /* Tabs */
  --tab-underline-height: 3px;
  --tab-underline-radius: 6px;
  --tab-transition: 240ms cubic-bezier(0.2, 0.9, 0.3, 1);

  /* Scalable fonts */
  --font-base: clamp(14px, 1.35vw, 16px);
  --font-lg: clamp(18px, 2vw, 22px);
  --font-sm: clamp(12px, 1vw, 14px);
}

/* Reduce motion */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}

/* -------------------------
   Base Layout
------------------------- */

body {
  margin: 0;
  background: var(--bg-page);
  color: var(--text);
  font-size: var(--font-base);
}

.app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* -------------------------
   Topbar
------------------------- */

.topbar {
  background: var(--surface);
  border-bottom: 1px solid rgba(17, 24, 39, 0.04);
  padding: 1rem 1.25rem;
  position: sticky;
  top: 0;
  z-index: 40;
  backdrop-filter: blur(6px);
}

.topbar-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

/* TITLE */
.brand {
  margin: 0;
  font-size: var(--font-lg);
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* -------------------------
   Tabs (Perfect Underline)
------------------------- */

.controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex-wrap: wrap;
  margin-left: auto;
}

/* Base tab */
.tab-btn {
  background: transparent;
  border: none;
  padding: 0.45rem 0.8rem;
  font-weight: 600;
  color: var(--accent-600);
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: 42px;
  line-height: 1;
  border-radius: 6px;
  white-space: nowrap;
  font-size: var(--font-base);
}

/* Hover */
.tab-btn:hover {
  color: var(--accent-700);
}

/* Centered underline */
.tab-btn::after {
  content: "";
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: min(calc(100% - 20px), 200px);
  height: var(--tab-underline-height);
  border-radius: var(--tab-underline-radius);
  background: var(--accent-600);
  opacity: 0;
  transition: transform var(--tab-transition), opacity var(--tab-transition);
  transform-origin: center;
}

.tab-btn.active {
  color: var(--accent-700);
}
.tab-btn.active::after {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

/* -------------------------
   HAMBURGER TOGGLE
------------------------- */

.mobile-menu-toggle {
  display: none; /* hidden on desktop by default */
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1.6rem;
  padding: 0.25rem;
  margin-left: 0.5rem;
  line-height: 1;
  color: var(--accent-700);
}

/* -------------------------
   MOBILE TAB BEHAVIOR
   - Tabs are hidden under hamburger
   - Hamburger + title remain on same line
------------------------- */

@media (max-width: 650px) {
  .topbar-inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  }

  .controls {
    display: none; /* hide desktop tabs on mobile */
  }

  .mobile-menu-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

/* Extra small phones */
@media (max-width: 420px) {
  .brand {
    font-size: 16px;
  }
}

/* -------------------------
   MOBILE MENU OVERLAY
------------------------- */

/* -------------------------
   MOBILE MENU OVERLAY
------------------------- */

.mobile-menu-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: flex-start;       /* move to top instead of center */
  justify-content: center;       /* center horizontally */
  padding-top: 80px;             /* place box below header */
  z-index: 45;
}

.mobile-menu {
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  padding: 1rem 1.1rem;
  width: 90%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  animation: slideDown 0.25s ease;  /* smooth top animation */
}

/* Slide from top */
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


/* -------------------------
   Main Content Area
------------------------- */

.main-area {
  max-width: 1200px;
  margin: 1.25rem auto;
  width: 100%;
  padding: 0 1rem;
  flex: 1 1;
}

/* -------------------------
   Footer
------------------------- */

.site-footer {
  padding: 1rem;
  text-align: center;
  font-size: var(--font-sm);
  color: var(--muted);
}

/* -------------------------
   Shared Cards
------------------------- */

.card {
  background: var(--surface);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  border: 1px solid rgba(0, 0, 0, 0.03);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

/* -------------------------
   Buttons
------------------------- */

.btn-primary,
.btn-success,
.btn-outline,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 0.95rem;
  border-radius: 0.6rem;
  font-weight: 600;
  cursor: pointer;
  border: 1.2px solid transparent;
  font-size: var(--font-sm);
}

.btn-primary {
  background: var(--accent-600);
  color: #fff;
}

.btn-success {
  background: linear-gradient(135deg, #10b981, #34d399);
  color: #fff;
}

.btn-outline {
  background: transparent;
  color: var(--accent-600);
  border: 1.6px solid var(--accent-500);
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

/* tiny buttons */
.small-btn,
.tiny-btn {
  padding: 0.4rem 0.7rem;
  border-radius: 0.6rem;
  font-size: var(--font-sm);
}

/* -------------------------
   Inputs
------------------------- */

.input,
.select,
.file-input {
  width: 100%;
  padding: 0.6rem 0.75rem;
  font-size: var(--font-base);
  border-radius: 0.6rem;
  border: 1px solid #e6e9ef;
  background: #fff;
  transition: box-shadow 0.12s ease, transform 0.12s ease;
}
.input:focus,
.select:focus {
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.08);
  transform: translateY(-1px);
}

/* grids */
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}
@media (max-width: 720px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
}

/* helpers */
.hint {
  font-size: var(--font-sm);
  color: var(--muted);
  margin-top: 0.35rem;
}
.mono {
  font-family: ui-monospace, Menlo, monospace;
}
.empty {
  padding: 1rem;
  text-align: center;
  color: var(--muted);
}

/* responsive spacing */
@media (max-width: 1000px) {
  .main-area {
    padding: 0 0.75rem;
  }
}

/* -------------------------
   Logout button
------------------------- */

.logout-btn {
  background: #ef4444;
  color: #fff;
  border: none;
  height: 35px !important;
}

.logout-btn:hover {
  background: #dc2626;
  color: #fff;
}

.site-footer {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

.footer-support a {
  text-decoration: none;
}

/* --- BLUR WHEN CARD IS OPEN --- */
.app-root.blur-active {
  filter: blur(4px);
  pointer-events: none; /* prevent clicking behind */
}

/* -------------------------
   Responsive Internship Card Wrapper
-------------------------- */

/* Default (mobile-first) */
.internship-card-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 90%;
  max-width: 480px; /* mobile width */
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Medium screens (tablets & small laptops) */
@media (min-width: 768px) {
  .internship-card-wrapper {
    width: 80%;
    max-width: 650px;
  }
}

/* Large screens (desktop & wide monitors) */
@media (min-width: 1024px) {
  .internship-card-wrapper {
    width: 70%;
    max-width: 900px; /* bigger card */
  }
}

/* Very large screens (big desktops) */
@media (min-width: 1440px) {
  .internship-card-wrapper {
    width: 60%;
    max-width: 1100px; /* ultra-wide */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;;2BAE2B;AAC3B;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;;EAEjB,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,sDAAsD;;EAEtD,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,kBAAkB;AAClB;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;2BAE2B;;AAE3B;EACE,0BAA0B;EAC1B,+CAA+C;EAC/C,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA,UAAU;AACV;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,0CAA0C;EAC1C,6BAA6B;EAC7B,UAAU;EACV,0EAA0E;EAC1E,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa,EAAE,iCAAiC;EAChD,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;;;2BAI2B;;AAE3B;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,aAAa,EAAE,gCAAgC;EACjD;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;2BAE2B;;AAE3B;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB,QAAQ,kCAAkC;EACjE,uBAAuB,QAAQ,wBAAwB;EACvD,iBAAiB,cAAc,2BAA2B;EAC1D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B,GAAG,yBAAyB;AAC7D;;AAEA,mBAAmB;AACnB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,SAAO;AACT;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,qCAAqC;EACrC,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;2BAE2B;;AAE3B;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;2BAE2B;;AAE3B;;;EAGE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,uDAAuD;AACzD;AACA;;EAEE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA;;4BAE4B;;AAE5B,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,UAAU;EACV,gBAAgB,EAAE,iBAAiB;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,6CAA6C;AAC7C;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,UAAU;IACV,gBAAgB,EAAE,gBAAgB;EACpC;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,iBAAiB,EAAE,eAAe;EACpC;AACF","sourcesContent":["/* App.css — fully responsive with perfect underline + mobile tab layout */\n\n/* -------------------------\n   Theme Variables\n------------------------- */\n:root {\n  --bg-page: rgb(249, 243, 243);\n  --surface: #ffffff;\n  --text: #111827;\n  --muted: #6b7280;\n  --accent-500: #6366f1;\n  --accent-600: #4f46e5;\n  --accent-700: #4338ca;\n  --radius: 1rem;\n  --shadow-sm: 0 4px 12px rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 6px 20px rgba(0, 0, 0, 0.08);\n  --success: #10b981;\n  --danger: #ef4444;\n\n  /* Tabs */\n  --tab-underline-height: 3px;\n  --tab-underline-radius: 6px;\n  --tab-transition: 240ms cubic-bezier(0.2, 0.9, 0.3, 1);\n\n  /* Scalable fonts */\n  --font-base: clamp(14px, 1.35vw, 16px);\n  --font-lg: clamp(18px, 2vw, 22px);\n  --font-sm: clamp(12px, 1vw, 14px);\n}\n\n/* Reduce motion */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition: none !important;\n    animation: none !important;\n  }\n}\n\n/* -------------------------\n   Base Layout\n------------------------- */\n\nbody {\n  margin: 0;\n  background: var(--bg-page);\n  color: var(--text);\n  font-size: var(--font-base);\n}\n\n.app-root {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* -------------------------\n   Topbar\n------------------------- */\n\n.topbar {\n  background: var(--surface);\n  border-bottom: 1px solid rgba(17, 24, 39, 0.04);\n  padding: 1rem 1.25rem;\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  backdrop-filter: blur(6px);\n}\n\n.topbar-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n/* TITLE */\n.brand {\n  margin: 0;\n  font-size: var(--font-lg);\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n/* -------------------------\n   Tabs (Perfect Underline)\n------------------------- */\n\n.controls {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-left: auto;\n}\n\n/* Base tab */\n.tab-btn {\n  background: transparent;\n  border: none;\n  padding: 0.45rem 0.8rem;\n  font-weight: 600;\n  color: var(--accent-600);\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  height: 42px;\n  line-height: 1;\n  border-radius: 6px;\n  white-space: nowrap;\n  font-size: var(--font-base);\n}\n\n/* Hover */\n.tab-btn:hover {\n  color: var(--accent-700);\n}\n\n/* Centered underline */\n.tab-btn::after {\n  content: \"\";\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  transform: translateX(-50%) scaleX(0);\n  width: min(calc(100% - 20px), 200px);\n  height: var(--tab-underline-height);\n  border-radius: var(--tab-underline-radius);\n  background: var(--accent-600);\n  opacity: 0;\n  transition: transform var(--tab-transition), opacity var(--tab-transition);\n  transform-origin: center;\n}\n\n.tab-btn.active {\n  color: var(--accent-700);\n}\n.tab-btn.active::after {\n  transform: translateX(-50%) scaleX(1);\n  opacity: 1;\n}\n\n/* -------------------------\n   HAMBURGER TOGGLE\n------------------------- */\n\n.mobile-menu-toggle {\n  display: none; /* hidden on desktop by default */\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 1.6rem;\n  padding: 0.25rem;\n  margin-left: 0.5rem;\n  line-height: 1;\n  color: var(--accent-700);\n}\n\n/* -------------------------\n   MOBILE TAB BEHAVIOR\n   - Tabs are hidden under hamburger\n   - Hamburger + title remain on same line\n------------------------- */\n\n@media (max-width: 650px) {\n  .topbar-inner {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n  }\n\n  .controls {\n    display: none; /* hide desktop tabs on mobile */\n  }\n\n  .mobile-menu-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* Extra small phones */\n@media (max-width: 420px) {\n  .brand {\n    font-size: 16px;\n  }\n}\n\n/* -------------------------\n   MOBILE MENU OVERLAY\n------------------------- */\n\n/* -------------------------\n   MOBILE MENU OVERLAY\n------------------------- */\n\n.mobile-menu-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  display: flex;\n  align-items: flex-start;       /* move to top instead of center */\n  justify-content: center;       /* center horizontally */\n  padding-top: 80px;             /* place box below header */\n  z-index: 45;\n}\n\n.mobile-menu {\n  background: var(--surface);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-md);\n  padding: 1rem 1.1rem;\n  width: 90%;\n  max-width: 420px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  animation: slideDown 0.25s ease;  /* smooth top animation */\n}\n\n/* Slide from top */\n@keyframes slideDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n/* -------------------------\n   Main Content Area\n------------------------- */\n\n.main-area {\n  max-width: 1200px;\n  margin: 1.25rem auto;\n  width: 100%;\n  padding: 0 1rem;\n  flex: 1;\n}\n\n/* -------------------------\n   Footer\n------------------------- */\n\n.site-footer {\n  padding: 1rem;\n  text-align: center;\n  font-size: var(--font-sm);\n  color: var(--muted);\n}\n\n/* -------------------------\n   Shared Cards\n------------------------- */\n\n.card {\n  background: var(--surface);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid rgba(0, 0, 0, 0.03);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n.card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-md);\n}\n\n/* -------------------------\n   Buttons\n------------------------- */\n\n.btn-primary,\n.btn-success,\n.btn-outline,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 0.95rem;\n  border-radius: 0.6rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1.2px solid transparent;\n  font-size: var(--font-sm);\n}\n\n.btn-primary {\n  background: var(--accent-600);\n  color: #fff;\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #10b981, #34d399);\n  color: #fff;\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--accent-600);\n  border: 1.6px solid var(--accent-500);\n}\n\n.btn-secondary {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* tiny buttons */\n.small-btn,\n.tiny-btn {\n  padding: 0.4rem 0.7rem;\n  border-radius: 0.6rem;\n  font-size: var(--font-sm);\n}\n\n/* -------------------------\n   Inputs\n------------------------- */\n\n.input,\n.select,\n.file-input {\n  width: 100%;\n  padding: 0.6rem 0.75rem;\n  font-size: var(--font-base);\n  border-radius: 0.6rem;\n  border: 1px solid #e6e9ef;\n  background: #fff;\n  transition: box-shadow 0.12s ease, transform 0.12s ease;\n}\n.input:focus,\n.select:focus {\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.08);\n  transform: translateY(-1px);\n}\n\n/* grids */\n.grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n@media (max-width: 720px) {\n  .grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* helpers */\n.hint {\n  font-size: var(--font-sm);\n  color: var(--muted);\n  margin-top: 0.35rem;\n}\n.mono {\n  font-family: ui-monospace, Menlo, monospace;\n}\n.empty {\n  padding: 1rem;\n  text-align: center;\n  color: var(--muted);\n}\n\n/* responsive spacing */\n@media (max-width: 1000px) {\n  .main-area {\n    padding: 0 0.75rem;\n  }\n}\n\n/* -------------------------\n   Logout button\n------------------------- */\n\n.logout-btn {\n  background: #ef4444;\n  color: #fff;\n  border: none;\n  height: 35px !important;\n}\n\n.logout-btn:hover {\n  background: #dc2626;\n  color: #fff;\n}\n\n.site-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n}\n\n.footer-support a {\n  text-decoration: none;\n}\n\n/* --- BLUR WHEN CARD IS OPEN --- */\n.app-root.blur-active {\n  filter: blur(4px);\n  pointer-events: none; /* prevent clicking behind */\n}\n\n/* -------------------------\n   Responsive Internship Card Wrapper\n-------------------------- */\n\n/* Default (mobile-first) */\n.internship-card-wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  width: 90%;\n  max-width: 480px; /* mobile width */\n  max-height: 90vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Medium screens (tablets & small laptops) */\n@media (min-width: 768px) {\n  .internship-card-wrapper {\n    width: 80%;\n    max-width: 650px;\n  }\n}\n\n/* Large screens (desktop & wide monitors) */\n@media (min-width: 1024px) {\n  .internship-card-wrapper {\n    width: 70%;\n    max-width: 900px; /* bigger card */\n  }\n}\n\n/* Very large screens (big desktops) */\n@media (min-width: 1440px) {\n  .internship-card-wrapper {\n    width: 60%;\n    max-width: 1100px; /* ultra-wide */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
